import React from "react";
import { Container } from "semantic-ui-react";
import styled from "styled-components";
import HVLogo from "../../assets/hospitable-viking-blue.png";

const Title = styled.div`
  text-align: center;
  color: white;
  font-size: 24px;
`;

const AppHeader = (props) => {
  return (
    <Container
      fluid
      style={{
        display: "flex",
        flexDirection: "column",
        height: "200px",
        alignItems: "center",
        marginBottom: "20px",
        gridRowStart: 1,
        gridRowEnd: 2,
      }}
    >
      <img
        className="ui small rounded image"
        alt="Hospitable Viking Logo"
        src={HVLogo}
        style={{
          display: "block",
          margin: "15px auto",
          width: "150px",
        }}
      ></img>
      <Title>{props.title}</Title>
    </Container>
  );
};

export default AppHeader;
